import { FC } from 'react';
import { Button, Flex, Stack, StackProps, Text } from '@chakra-ui/react';
import { Failed } from './failed';
import { InfoTag, PlainOrInfoTags } from './plain-or-info-tags';
import { Success } from './success';

type ReadOnlyViewProps = {
  label: string;
  tags: string[] | InfoTag[];
  onEditClick: () => void;
  showSaved: boolean;
  showFailed: boolean;
};

export const ReadOnlyView: FC<ReadOnlyViewProps> = ({
  label,
  tags,
  onEditClick,
  showSaved,
  showFailed,
}) => {
  return (
    <Border>
      <Flex justify="space-between" align="center">
        <Text fontWeight="semibold">{label}</Text>
        <Button
          onClick={onEditClick}
          colorScheme="blue"
          textDecoration="underline"
          variant="ghost"
          data-testid="edit-button"
        >
          Edit
        </Button>
      </Flex>

      {tags.length === 0 && <Text color="gray.500">None set</Text>}

      {tags.length > 0 && (
        <PlainOrInfoTags tags={tags} testId="read-only-tag" />
      )}

      {showSaved && (
        <Success mt={2} title="Saved" data-testid="save-success-message" />
      )}
      {showFailed && (
        <Failed
          mt={2}
          title="Update failed"
          data-testid="save-failed-message"
        />
      )}
    </Border>
  );
};

export const Border: FC<StackProps> = (props) => (
  <Stack mt={4} px={6} pt={4} pb={6} layerStyle="border" {...props} />
);
